export default "__VITE_ASSET__705aab49__"